import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionContractState: Dtos.TrialInstitutionContract & IRegistrationFormState = {
    id: null,
    trialInstitutionId: null,
    trialInstitution: null,
    name: null,
    location : null,
    dateSentToSite: null,
    dateConfirmedBySite: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    sourceDocuments: []
}

export interface ITrialInstitutionContractReduxFormState {
    id: IFieldState<number>,
    trialInstitutionId: IFieldState<number>,
    trialInstitution: IFieldState<Dtos.TrialInstitution>,
    name: IFieldState<string>,
    location : IFieldState<string>,
    dateSentToSite: IFieldState<string>,
    dateConfirmedBySite: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    sourceDocuments: IFieldState<Dtos.SourceDocument[]>
}
